import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import {
  AdvertiserStatusEnum,
  AdvertiserStatusEnumMapping,
  AdvertiserStatusInterface,
} from "src/app/shared/enum/advertiser-status";
import { AdvertiserDetailsInterface } from "src/app/shared/models/advertiser/profile.interface";
import { CommonParamsIberis } from "src/app/shared/models/iberis/paramsForGetAll";
import { invokeApproveAdvertiser } from "src/app/store/advertiser/advertiser.actions";
import {
  loadingApproveAdvertiserSelector,
} from "src/app/store/advertiser/advertiser.selectors";
import { AppStateInterface } from "src/app/store/appState.interface";
import { invokeCreateClient } from "src/app/store/clientIberis/clientIberis.actions";
import { environment } from "src/environments/environment";
import { invokeSideBarNews } from "src/app/store/admin/admin.actions";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import {
  catchForbiddenError,
  catchServerError,
} from "src/app/store/user/user.actions";
import {
  catchForbiddenErrorSelector,
  catchServerErrorSelector,
} from "src/app/store/user/user.selectors";

@Component({
  selector: "app-update-advertiser-status",
  templateUrl: "./update-advertiser-status.component.html",
})
export class UpdateAdvertiserStatusComponent
  extends BaseComponent
  implements OnInit
{
  @Input("advertiser") advertiser: AdvertiserDetailsInterface;
  form: FormGroup;
  advertiserStatus: AdvertiserStatusInterface[];
  loading: boolean;
  loading$: Observable<boolean | null>;
  advertiserStatusEnum = AdvertiserStatusEnum;
  catchServerError$: Observable<boolean | null>;
  catchForbiddenError$: Observable<boolean | null>;

  isUpdate: boolean = false;

  status: AdvertiserStatusEnum;

  statusEnum = AdvertiserStatusEnum;
  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private saveHistory: SaveUserHistoryService
  ) {
    super(store);
    this.form = this.fb.group({
      status: [null],
    });
    this.loading$ = this.store
      .pipe(select(loadingApproveAdvertiserSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.closeModal();
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.catchServerError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.store.dispatch(catchServerError({ serverError: null }));
      }
    });
    this.loading$.subscribe((data) => {
      if (data) this.loading = data;
    });
    this.form.patchValue({ status: this.advertiser.status });
    this.advertiserStatus = Object.keys(AdvertiserStatusEnum)
      .filter(
        (value) =>
          isNaN(Number(value)) === true &&
          value != AdvertiserStatusEnum.EMAIL_VERIFICATION
      )
      .map((key: string | any) => ({
        id: AdvertiserStatusEnum[key as keyof typeof AdvertiserStatusEnum],
        value:
          AdvertiserStatusEnumMapping[key as keyof typeof AdvertiserStatusEnum],
      }));
  }
  closeModal() {
    this.modalService.dismissAll();
  }
  updateStatus() {
    this.loading = true;
    if (this.isUpdate) {
      this.createIberisAccount();
    } else {
      this.updateAdvertiserStatus();
    }
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.PATCH,
      UserHistoryServicesEnum.UPDATE_ADVERTISER_STATUS
    );
  }

  updateAdvertiserStatus() {
    if (
      !this.advertiser.verified &&
      this.status != AdvertiserStatusEnum.DISABLED &&
      this.status != AdvertiserStatusEnum.EMAIL_VERIFICATION
    ) {
      this.loading = false;
      this.toastr.error(
        this.translate.instant(
          "response.error.CANT_APPROVE_ADVERTISER_ACCOUNT_NOT_VERIFIED"
        ),
        this.translate.instant("response.errorTitle")
      );
      return;
    } else if (
      this.advertiser.iberis == null &&
      this.status == AdvertiserStatusEnum.ENABLED
    ) {
      if (
        this.advertiser.status != AdvertiserStatusEnum.EMAIL_VERIFICATION &&
        this.advertiser.verified
      ) {
        this.createIberisAccount();
        return;
      }
      return;
    }
    this.store.dispatch(
      invokeApproveAdvertiser({
        dto: {
          email: this.advertiser.email,
          status: this.status,
          iberis: this.advertiser.iberis,
        },
      })
    );
    this.store.dispatch(invokeSideBarNews());
  }
  createIberisAccount() {
    let createClient: any = {
      price_list_id: environment.IBERIS.PRICE_ID,
      first_name: this.advertiser?.firstName,
      last_name: this.advertiser?.lastName,
      email: this.advertiser?.email.toLowerCase(),
      phone: this.advertiser?.phone,
      website: this.advertiser?.website,
      company: this.advertiser?.companyName,
      display_name: 1,
      activity_id: this.advertiser?.companyActivity,
      currency_id: "rorJ",
      deadline_id: environment.IBERIS.DEADLINE_ID,
      reference: "Relead",
      title: 1,
    };
    if (this.advertiser.website == null) {
      createClient.website = "https://relead.tn/";
    }

    let params: CommonParamsIberis = {
      lang: "fr",
      companyId: environment.IBERIS.IBERIS_COMPANY_ID,
    };
    this.store.dispatch(
      invokeCreateClient({
        params: params,
        createClient: createClient,
      })
    );
  }

  onChecked(event: any) {
    this.isUpdate = event.target.checked;
  }

  retrieveStatus() {
    this.status = this.form.get("status")?.value;
  }
}
